const blue = "#2B72FE";
const gray = "#808080";
export const red = "#E63737";
export const orange = "#FF822F";
export const green = "#44B939";
export const greenStatusBg = "#0B8F1D";

export const getTextColor = (score, cutScore1, cutScore2) => {
  score = parseInt(score);
  cutScore1 = parseInt(cutScore1);
  cutScore2 = parseInt(cutScore2);
  let color = score > cutScore2 ? green : score > cutScore1 ? orange : red;
  return color;
};

export const getTextColorP = (proficiencyKey) => {
  console.log(proficiencyKey.proficiency_key);
  let color =
    proficiencyKey === "0" ? red : proficiencyKey === "1" ? orange : green;
  return color;
};

export const getStatusColor = (value) => {
  let color =
    value.toLowerCase() === "unassigned"
      ? red
      : value.toLowerCase() === "assigned"
      ? blue
      : green;
  return color;
};

export const getOnlineOfflineColor = (value) => {
  let color = value.toLowerCase() === "n" ? red : green;
  return color;
};

export const getStudentState = (score) => {
  const color =
    score > "3" ? green : score === "2" ? gray : score === "1" ? red : gray;
  return color;
};

export const getGradient = (score, cutScore1, cutScore2) => {
  const color = getTextColor(score, cutScore1, cutScore2);

  // color === orange
  if (color === "#FF822F") {
    return "orange";
    // color === red
  } else if (color === "#E63737") {
    return "red";
    // color === green
  } else if (color === "#44B939") {
    return "green";
  } else {
    return "inherit";
  }
};

// background: rgb(255,133,80);
// background: linear-gradient(90deg, rgba(255,133,80,1) 0%, rgba(255,130,32,1) 50%, rgba(255,128,0,1) 100%);
